<script setup lang="ts">
import type { ArticleTemplateProps } from '~/components/Article/articleTemplates';

import ArticleProseBody from '~/components/Article/ArticleProseBody.vue';
import ArticleTemplateShell from '~/components/Article/ArticleTemplateShell.vue';
import { useArticleTemplateData } from '~/composables/Learn/Article/useArticleTemplateData';
import { extractArticleGuideItems } from '~/utils/article';

const props = withDefaults(defineProps<ArticleTemplateProps>(), {
  preview: false,
  keepReading: () => [],
  signUpLink: undefined,
  showSignUpCta: true,
});

const emit = defineEmits<{
  signUpClick: [];
}>();

const { data } = useArticleTemplateData(toRef(props, 'article'), toRef(props, 'preview'));

// Prose-first: the TOC is the body's own sentence-case H2s, same as the
// default blog.
const guideItems = computed(() => extractArticleGuideItems(data.value?.body ?? ''));
</script>

<template>
  <ArticleTemplateShell
    :article="article"
    :data="data"
    :guide-items="guideItems"
    :preview="preview"
    :keep-reading="keepReading"
    :sign-up-link="signUpLink"
    :show-sign-up-cta="showSignUpCta"
    @sign-up-click="emit('signUpClick')"
  >
    <template #default="{ data: content }">
      <ArticleProseBody :content="content.body" />
    </template>
  </ArticleTemplateShell>
</template>
